export default __webpack_public_path__ + "static/media/left-chevron.a78fcd13.svg";